function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import PageData from '../page/Page.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Checkbox from '../../common/form/Checkbox.react';
import Button from '../../common/Button.react';
var PpcPageDetails = function PpcPageDetails() {
  var _useParams = useParams(),
    app = _useParams.app;
  var navigate = useNavigate();
  var dispatch = useDispatch();
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    title = _useState2[0],
    setTitle = _useState2[1];
  var pageID = state._id,
    internalUrl = state.internalUrl,
    banner = state.banner,
    breadcrumbs = state.breadcrumbs,
    archived = state.archived;
  useEffect(function () {
    if (state.title) setTitle(state.title);
  }, [state]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Section Details",
    button: {
      label: 'Custom Content',
      type: 'add',
      onClick: function onClick() {
        return navigate("/".concat(app, "/page-components/").concat(pageID));
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return setTitle(e.target.value);
    }
  }), title && title !== state.title && /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    style: {
      marginBottom: 20
    },
    onClick: function onClick() {
      dispatch({
        type: ppcActions.page,
        payload: {
          formData: {
            pageID: pageID,
            title: title,
            apiID: 'page-banner-title'
          },
          method: 'put',
          route: 'details'
        }
      });
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "URL",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: internalUrl
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Show Page Banner"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: banner === null || banner === void 0 ? void 0 : banner.isVisible,
    apiID: "page-banner-is-visible",
    onChange: function onChange(val) {
      dispatch({
        type: ppcActions.page,
        payload: {
          formData: {
            pageID: pageID,
            isVisible: val,
            apiID: 'page-banner-is-visible'
          },
          method: 'put',
          route: 'page-banner-is-visible'
        }
      });
    },
    disabled: archived,
    label: banner !== null && banner !== void 0 && banner.isVisible ? 'Yes' : 'No'
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Show Breadcrumbs"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.isVisible,
    apiID: "breadcrumbs-is-visible",
    onChange: function onChange(val) {
      dispatch({
        type: ppcActions.page,
        payload: {
          formData: {
            pageID: pageID,
            isVisible: val,
            apiID: 'breadcrumbs-is-visible'
          },
          method: 'put',
          route: 'breadcrumbs-is-visible'
        }
      });
    },
    disabled: archived,
    label: breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.isVisible ? 'Yes' : 'No'
  }))));
};
export default PpcPageDetails;